import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import { getContentType } from "@/utils/getContentType";
import { isFont } from "@/utils/pinMediaType";
import { useMemo } from "react";

/**
 * 采集详情页PV上报
 * @param pin - 采集详情页数据
 */
export function usePinDetailPV(pin: IPin) {
  // 使用useMemo是为了，及时上报PV
  useMemo(() => {
    if (!pin || typeof window === "undefined") return;

    const pageData = getPageData();
    const trackData: Record<string, any> = {
      ...pageData,
      sub_page_nm: getContentType(pin),
      scene_name: pin?.raw_text || undefined,
    };

    if (pin?.file_material?.material_id) {
      trackData.content_id = pin.file_material.material_id;
    }

    if (isFont(pin)) {
      trackData.content_type = "字体";
    }

    pvTracker(trackData);
  }, [pin?.pin_id]);
}
